import { useEffect } from "react";

// Holders currently mounted. A settings sheet view can claim the class over a
// page that already holds it (a GPT conversation); the first to unmount must not
// strip it from the other.
let holders = 0;

/**
 * Marks the page as managing keyboard layout itself (via KeyboardAvoidingView).
 *
 * The iOS shell (AppViewController.keyboardWillShow) checks <html> for the
 * `keyboard-managed` class and pins the WKWebView scroll offset to zero while
 * the keyboard is open. Without it, WebKit's native scroll-to-reveal pans the
 * whole rendered layer — header, navbar, every fixed element — above the
 * keyboard when an input near the bottom is focused.
 */
export function useKeyboardManaged(): void {
  useEffect(() => {
    holders += 1;
    document.documentElement.classList.add("keyboard-managed");
    return () => {
      holders -= 1;
      if (holders === 0) {
        document.documentElement.classList.remove("keyboard-managed");
      }
    };
  }, []);
}
